<template>
  <b-modal class="modal-sm" id="ModalGenerateNewProof" ref="rejectBatch-modal" :title="generateNewProofModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="" @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'marker']" size="1x" class="mr-2"/> {{ generateNewProofModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <h5 class="py-2">{{ t('generateNewProofModalHeading','generateNewProofModalHeading') }}</h5>
      <b-form-group>
        <b-form-checkbox-group id="delivery-options" v-model="deliveryOptions" name="flavour-2">
          <b-form-checkbox value="createCustomers">{{t('labelCreateCustomersNotAlreadyInTheSystem','labelCreateCustomersNotAlreadyInTheSystem')}}</b-form-checkbox>
          <b-form-checkbox value="updateDetails">{{t('labelUpdateDetails','labelUpdateDetails')}}</b-form-checkbox>
          <b-form-checkbox value="updateDeliveryDetails">{{t('labelUpdateDeliveryDetailsFromData','labelUpdateDeliveryDetailsFromData')}}</b-form-checkbox>
          <b-form-checkbox value="updateDeliveryPrefs">{{t('labelSendPost','labelSendPost')}}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <ResponseInfo v-if="getResponseInfo.responseName == 'documentsView'"></ResponseInfo>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <button aria-label="RejectAllDocs" data-dismiss="modal" class="btn btn-primary" type="button" @click="generateNewProof()">
          <div v-if="buttonIsBusy">
            <div class="sk-folding-cube">
              <div class="sk-cube1 sk-cube"></div>
              <div class="sk-cube2 sk-cube"></div>
              <div class="sk-cube4 sk-cube"></div>
              <div class="sk-cube3 sk-cube"></div>
            </div>
          </div>
          <div v-if="!buttonIsBusy">
            <fontAwesomeIcon :icon="['fa', 'plus']" class="text-light mr-2"/> {{ t('generateProofButtonText', 'generateProofButtonText')}}
          </div>
        </button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalGenerateNewProof',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal'
  ],
  data () {
    return {
      deliveryOptions: {},
      generateNewProofModal: {},
      buttonIsBusy: false,
      modalIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    generateNewProof() {
      /*
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool',{
        action: 'rejectAllDocuments',
        documents: this.rejectBatchModal.docuData,
        rejectReason: this.rejectReason,
        batchId: this.$route.query.batch
      })
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['rejectBatch-modal'].hide()
          this.$router.push({name: "manage_batches"})
        }
      })
      */
    }
  },
  created() {
    this.generateNewProofModal = this.$attrs.modal
  },
  filters:{
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #modalAddressBook___BV_modal_outer_ >>> .modal-content{
  min-width: 750px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #modalAddressBook___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
/*
.modal-open #modalAddressBook___BV_modal_outer_ >>> #addressbook-customers-table tbody tr{
  background-color: pink !important;
}
*/
</style>
